import { render, staticRenderFns } from "./NewsDelete.vue?vue&type=template&id=6df54bc8&"
import script from "./NewsDelete.vue?vue&type=script&lang=js&"
export * from "./NewsDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports